export default "__VITE_ASSET__DNMfReJU__"